import styled from 'styled-components'
import Colors from 'constants/colors'
import Threshold from 'constants/threshold'

export const ContactsPageStyled = styled.main`
  padding-top: 120px;
  min-height: calc(100vh - 260px);

  h1 {
    margin-bottom: 20px;
    padding: 0 23px;
  }
  h2 {
    margin-bottom: 30px;
    padding: 0 23px;
  }
  .description {
    line-height: 22px;
    text-align: center;
    padding: 0 23px;
    margin-bottom: 40px;
  }

  @media (min-width: ${Threshold.phone}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 87px;
    h2 {
      margin-bottom: 50px;
    }
    .description {
      margin-bottom: 78px;
      font-size: 20px;
      line-height: 35px;
    }
  }
`

export const ContactsTitle = styled.h1`
  margin-bottom: 20px;
  padding: 0 23px;
`

export const ContactsSubtitle = styled.h2`
  margin-bottom: 30px;
  padding: 0 23px;

  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 50px;
  }
`

export const ContactsDescription = styled.p`
  line-height: 22px;
  text-align: center;
  padding: 0 23px;
  margin-bottom: 40px;

  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 78px;
    font-size: 20px;
    line-height: 35px;
  }
`
